<template>
    <div class="totalWidthBox">
        <div class="top clearfix">
            <div class="title" v-if="widthObj.widthType==4">退货宽度明细</div>
            <div class="title" v-else-if="widthObj.widthType==5">剩余宽度明细</div>
            <div class="title" >销售宽度明细</div>
            <div class="change" v-if="isCanEdit" @click="isEdit=!isEdit">{{isEdit?'取消修改':'修改'}}</div>
        </div>
        <div class="overflow">
            <div class="widthList" v-for="(list,index) in widthObj.widthList" :Key="index">
                <div class="path">
                    <div class="show">
                        <span class="pathTitle">展示</span>
                        <span class="titletext">长度：</span><input class="showiIn" :disabled="!isEdit||returnEdit" v-model="list.length"/>
                        <span class="titletext">厚度：</span><input class="showiIn" :disabled="!isEdit||returnEdit" v-model="list.thickness"/>
                    </div>
                    <div class="formula">
                        <span class="pathTitle">公式</span>
                        <span class="titletext"><span class="backRedColor">*</span>长度(m)：</span><input class="showiIn" value="number" :disabled="!isEdit||returnEdit" v-model="list.length_formula" @blur="calculation()" @input="watchStock()"/>
                        <span class="titletext"><span class="backRedColor">*</span>厚度(mm)：</span><input size="mini"  class="showiIn" value="number" :disabled="!isEdit||returnEdit" v-model="list.thickness_formula" @blur="calculation()" @input="watchStock()"/>
                    </div>
                </div>
                <div class="middle">
                    <div class="widthlistC clearfix">
                        <div class="widthInputC" v-for="(item,ind) in list.width" :Key="ind">
                            <!-- 有编辑权限 widthObj.widthList[index].width[ind] 可以为空   查看 widthObj.widthList[index].width[ind] 为空不显示 -->
                            <!-- @keyup.enter.native="()=>{inputAddEnter(widthObj.widthList[index].width[ind],index,ind)}" -->
                            <el-input class="widthInput"  v-model="widthObj.widthList[index].width[ind]" :readonly="!isEdit"  @input="(e)=>{inputAdd(widthObj.widthList[index].width[ind],index,ind)}"></el-input>
                            <div class="delWidth" v-if="isEdit" @click="delWidth(index,ind)"></div>
                        </div>
                    </div>
                    <div class="emptyStyle" @click="clear(index)" v-if="isEdit">
                        <span>清空</span>
                    </div>
                </div>
                <div class="calcBox clearfix">
                    <div class="calCShell clearfix">
                        <div class="calC clearfix">
                            <div class="caclTitle">均宽余数(cm)：</div>
                            <input class="showiIn" :disabled="!isEdit" v-model="list.width_other"  @blur="calculation()"/>
                        </div>
                        <div class="calC clearfix">
                            <div class="caclTitle">层数：</div>
                            <input class="showiIn" :disabled="!isEdit" v-model="list.layer_number" @blur="calculation()"/>
                        </div>
                        <div class="calC clearfix">
                            <div class="caclTitle">片数：</div>
                            <input class="showiIn" :disabled="!isEdit" v-model="list.pieces" @blur="calculation()"/>
                        </div>
                    </div>
                    <div class="total clearfix">
                        <!-- <div class="calC clearfix" v-if="!isEdit" style="width: 60px;">
                            <span v-html="`&ensp;`"></span>
                        </div> -->
                        <div class="calC clearfix">
                            <div class="caclTitle">总宽度：<span class="bold">{{list.countWidth}}cm</span></div>
                        </div>
                        <div class="calC clearfix">
                            <div class="caclTitle">立方数：</div>
                            <div class="bold" style="width: 120px;text-align: start;"><span class="bold">{{list.cube}}m³</span></div>
                        </div>
                        <div class="calC clearfix" v-if="isEdit">
                            <span class="iconfont icon-jia1 handle" v-if="index==0" @click="addDetailed"></span>
                            <span class="iconfont icon-jian2 handle" @click="delDetailed(index)"></span>
                        </div>
                    </div>
                    <!-- <div class="total">{{list.cube}}m³</div> -->
                </div>
                
            </div>
            <div class="calcBox" style="padding: 5px 20px;" v-if="widthObj.widthList.length>1">
                <div class="allTotal">
                混包合计： 
                <span class="allTotalspan">{{widthObj.widthList.length}}个规格</span>
                <span>{{countPieces}}片</span>
                <span class="allTotalspan">{{countCube}}m³</span>
                </div>
            </div>
            <div v-if="internalPreType==2">
                <div class="top clearfix">
                    <div class="title" >剩余宽度明细</div>
                    <div class="change" v-if="isCanEdit" @click="isEditB=!isEditB">{{isEditB?'取消修改':'修改'}}</div>
                </div>
                <div>
                    <div class="widthList" v-for="(list,index) in widthObjB.widthList" :Key="index">
                        <div class="path">
                            <div class="show">
                                <span class="pathTitle">展示</span>
                                <span class="titletext">长度：</span><input class="showiIn" :disabled="!isEditB||returnEdit" v-model="list.length"/>
                                <span class="titletext">厚度：</span><input class="showiIn" :disabled="!isEditB||returnEdit" v-model="list.thickness"/>
                            </div>
                            <div class="formula">
                                <span class="pathTitle">公式</span>
                                <span class="titletext"><span class="backRedColor">*</span>长度(m)：</span><input class="showiIn" value="number" :disabled="!isEditB||returnEdit" v-model="list.length_formula" @blur="calculationB()" @input="watchStock()"/>
                                <span class="titletext"><span class="backRedColor">*</span>厚度(mm)：</span><input size="mini"  class="showiIn" value="number" :disabled="!isEditB||returnEdit" v-model="list.thickness_formula" @blur="calculationB()" @input="watchStock()"/>
                            </div>
                        </div>
                        <div class="middle">
                            <div class="widthlistC clearfix">
                                <div class="widthInputC" v-for="(item,ind) in list.width" :Key="ind">
                                <el-input class="widthInput"  v-model="widthObjB.widthList[index].width[ind]" :readonly="!isEditB"  @input="(e)=>{inputAddB(widthObjB.widthList[index].width[ind],index,ind)}"></el-input>
                                    <div class="delWidth" v-if="isEditB" @click="delWidthB(index,ind)"></div>
                                </div>
                            </div>
                            <div class="emptyStyle" @click="clearB(index)" v-if="isEditB">
                                <span>清空</span>
                            </div>
                        </div>
                        <div class="calcBox clearfix">
                            <div class="calCShell clearfix">
                                <div class="calC clearfix">
                                    <div class="caclTitle">均宽余数(cm)：</div>
                                    <input class="showiIn" :disabled="!isEditB" v-model="list.width_other"  @blur="calculationB()"/>
                                </div>
                                <div class="calC clearfix">
                                    <div class="caclTitle">层数：</div>
                                    <input class="showiIn" :disabled="!isEditB" v-model="list.layer_number" @blur="calculationB()"/>
                                </div>
                                <div class="calC clearfix">
                                    <div class="caclTitle">片数：</div>
                                    <input class="showiIn" :disabled="!isEditB" v-model="list.pieces" @blur="calculationB()"/>
                                </div>
                            </div>
                            <div class="total clearfix">
                                <div class="calC clearfix">
                                    <div class="caclTitle">总宽度：<span class="bold">{{list.countWidth}}cm</span></div>
                                </div>
                                <div class="calC clearfix">
                                    <div class="caclTitle">立方数：</div>
                                    <div class="bold" style="width: 120px;text-align: start;"><span class="bold">{{list.cube}}m³</span></div>
                                </div>
                                <div class="calC clearfix" v-if="isEditB">
                                    <span class="iconfont icon-jia1 handle" v-if="index==0" @click="addDetailedB"></span>
                                    <span class="iconfont icon-jian2 handle" @click="delDetailedB(index)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calcBox" style="padding: 5px 20px;" v-if="widthObjB.widthList.length>1">
                    <div class="allTotal">
                    混包合计： 
                    <span class="allTotalspan">{{widthObjB.widthList.length}}个规格</span>
                    <span>{{countPiecesB}}片</span>
                    <span class="allTotalspan">{{countCubeB}}m³</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="noWidth"  v-if="widthObj.widthList.length<=0&&!isEdit&&!isEditB">暂无宽度明细</div>
        <div class="dialogBtnList clearfix">
            <div v-if="internalPreType==2" style="position: absolute;line-height: 30px;" class="bold">
                <span > 原包立方:{{oldCube}}m³</span>
                <span class="allTotalspan"> 拆包合计立方:{{newCountCube}}m³</span>
            </div>

            <el-button v-if="isEdit||isEditB" class="publicBtn dialogBtn" @click="widthEdit">修改</el-button>
            <el-button v-if="isEdit||isEditB" class="dialogBtn funcPublicBtn" @click="cancel">取消</el-button>
        </div>  
    </div>
</template>
<script>
export default {
    props:['edit','type','editReturn','list','listB','preType','initialCube','dialogvisible',"saleEdit",],
    data(){
        return{
            widthObj:{
                widthList:this.list,
            },
            widthObjB:{
                widthList:this.listB,
            },
            oldList:this.list,
            isEdit:false,
            isEditB:false,
            isCanEdit:this.edit,
            internalPreType: this.preType,
            oldCube: this.initialCube,
            countCube:"",
            countPieces:"",
            countCubeB:"",
            countPiecesB:"",
            newCountCube:"",
            is_sales:false,
            returnEdit:this.editReturn,
       }
    },
    created(){
        this.calculation();this.calculationB();
    },
    methods:{
        assignment(){
            this.widthObj.widthList.forEach((item)=>{
                item.width.push(null)
            })            
        },
        assignmentB(){
            this.widthObjB.widthList.forEach((item)=>{
                item.width.push(null)
            })            
        },
        //过滤为空的展示
        assignmentFilter(){
            this.widthObj.widthList.forEach(item=>{
                item.width = item.width.filter(res=>{
                    return res !=null;
                })
             })
        },
        //过滤为空的展示
        assignmentFilterB(){
            this.widthObjB.widthList.forEach(item=>{
                item.width = item.width.filter(res=>{
                    return res !=null;
                })
             })
        },
        // 回车 添加宽度
        inputAddEnter(num,allindex,index){
            return
            if(Number(num)>0){
                this.widthObj.widthList[allindex].width.push(null);
            }
            this.calculation();
        },
        // 值变化
        inputAdd(num,allindex,index){
            let length = 0;
            if(this.widthObj.widthList[allindex].width){
                length = this.widthObj.widthList[allindex].width.length
            }
            if(length == index+1){
                if(Number(num)>0){
                    this.widthObj.widthList[allindex].width.push(null);
                }
            }
            this.calculation()
        },
        // 值变化
        inputAddB(num,allindex,index){
            let length = 0;
            if(this.widthObjB.widthList[allindex].width){
                length = this.widthObjB.widthList[allindex].width.length
            }
            if(length == index+1){
                if(Number(num)>0){
                    this.widthObjB.widthList[allindex].width.push(null);
                }
            }
            this.calculationB()
        },
        //计算
        calculation(){
            //立方数（m³）=公式长度*公式厚度*总宽度*0.00001
            this.widthObj.widthList.forEach(item=>{
                item.newWidth = item.width.reduce(function(a, b){
                    if(b){
                        return Number(a) + Number(b); //宽度明细合计
                    }else{
                         return Number(a); //宽度明细合计
                    }
                }, 0); 
                if(item.width_other==''||item.width_other==undefined){
                    item.countWidth = item.newWidth;//均宽余数为空时，总宽度=宽度明细合计
                }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                    if(item.layer_number){
                        let numArr = this.$cloneJson(item.width);
                        let newNumArr = numArr.filter((res=>{
                            if(res !=0 && res!='' && res!= null){
                                return res;
                            }
                        }));
                        item.newWidth = this.$bc_add(this.$bc_mul(this.$bc_div(item.newWidth,newNumArr.length),item.layer_number),item.width_other);
                    }else{
                        item.newWidth = item.width_other;
                    }
                    item.countWidth = this.rounding(item.newWidth)
                }
                item.cube =this.keepLimit(this.$bc_mul(item.length_formula,item.thickness_formula,item.countWidth,0.00001));
            })
            let newArr = this.widthObj.widthList.map(a=>{
                return Number(a.cube)
            })
            let newCube = newArr.reduce(function(a, b){
                if(b){
                    return a + b; 
                }else{
                    return a
                }
            }, 0); 
            let newPiecesArr = this.widthObj.widthList.map(a=>{
                return Number(a.pieces)
            })
            let newPiecesCube = newPiecesArr.reduce(function(a, b){
                if(b){
                    return a + b; 
                }else{
                    return a
                }
            }, 0); 
            this.countCube = this.keepLimit(newCube);
            this.countPieces = this.rounding(newPiecesCube);
            this.newCountCube = this.$bc_add(this.countCube,this.countCubeB)
        },
        //计算
        calculationB(){
            //立方数（m³）=公式长度*公式厚度*总宽度*0.00001
            this.widthObjB.widthList.forEach(item=>{
                item.newWidth = item.width.reduce(function(a, b){
                    if(b){
                        return Number(a) + Number(b); //宽度明细合计
                    }else{
                         return Number(a); //宽度明细合计
                    }
                }, 0); 
                if(item.width_other==''||item.width_other==undefined){
                    item.countWidth = item.newWidth;//均宽余数为空时，总宽度=宽度明细合计
                }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                    if(item.layer_number){
                        let numArr = this.$cloneJson(item.width);
                        let newNumArr = numArr.filter((res=>{
                            if(res !=0 && res!='' && res!= null){
                                return res;
                            }
                        }));
                        item.newWidth = this.$bc_add(this.$bc_mul(this.$bc_div(item.newWidth,newNumArr.length),item.layer_number),item.width_other);
                    }else{
                        item.newWidth = item.width_other;
                    }
                    item.countWidth = this.rounding(item.newWidth)
                }
                item.cube =this.keepLimit(this.$bc_mul(item.length_formula,item.thickness_formula,item.countWidth,0.00001));
            })
            let newArr = this.widthObjB.widthList.map(a=>{
                return Number(a.cube)
            })
            let newCube = newArr.reduce(function(a, b){
                if(b){
                    return a + b; 
                }else{
                    return a
                }
            }, 0); 
            let newPiecesArr = this.widthObjB.widthList.map(a=>{
                return Number(a.pieces)
            })
            let newPiecesCube = newPiecesArr.reduce(function(a, b){
                if(b){
                    return a + b; 
                }else{
                    return a
                }
            }, 0); 
            this.countCubeB = this.keepLimit(newCube);
            this.countPiecesB = this.rounding(newPiecesCube);
            this.newCountCube = this.$bc_add(this.countCube,this.countCubeB)
        },
        //添加新明细
        addDetailed(){
            this.widthObj.widthList.push({
                length:'',
                thickness:'',
                length_formula:'',
                thickness_formula:'',
                width:[''],
                layer_number:'',//层数
                pieces:"",
                width_other:'',//均宽余数
                countWidth:'',//总宽度
                cube:'',//立方
            })
        },
        //添加新明细
        addDetailedB(){
            this.widthObjB.widthList.push({
                length:'',
                thickness:'',
                length_formula:'',
                thickness_formula:'',
                width:[''],
                layer_number:'',//层数
                pieces:"",
                width_other:'',//均宽余数
                countWidth:'',//总宽度
                cube:'',//立方
            })
        },
        //删除明细
        delDetailed(index){
            if(index==0&&this.widthObj.widthList.length==1){
                this.widthObj.widthList = [{
                    length:'',
                    thickness:'',
                    length_formula:'',
                    thickness_formula:'',
                    width:[''],
                    layer_number:'',//层数
                    pieces:"",
                    width_other:'',//均宽余数
                    countWidth:'',//总宽度
                    cube:'',//立方
                }]
            }else{
                this.widthObj.widthList.splice(index,1)
            }
            this.calculation()
        },
        //删除明细
        delDetailedB(index){
            if(index==0&&this.widthObjB.widthList.length==1){
                this.widthObj.widthList = [{
                    length:'',
                    thickness:'',
                    length_formula:'',
                    thickness_formula:'',
                    width:[''],
                    layer_number:'',//层数
                    pieces:"",
                    width_other:'',//均宽余数
                    countWidth:'',//总宽度
                    cube:'',//立方
                }]
            }else{
                this.widthObjB.widthList.splice(index,1)
            }
            this.calculationB()
        },
        //清空
        clear(index){
            this.widthObj.widthList[index].width = [''];
        },
        //清空
        clearB(index){
            this.widthObjB.widthList[index].width = [''];
        },
        delWidth(index,ind){
            if( this.widthObj.widthList[index].width.length==1){ 
                this.widthObj.widthList[index].width = [''];
            }else{
                this.widthObj.widthList[index].width.splice(ind,1)
            }
            this.calculation()
        },
        delWidthB(index,ind){
            if( this.widthObjB.widthList[index].width.length==1){ 
                this.widthObjB.widthList[index].width = [''];
            }else{
                this.widthObjB.widthList[index].width.splice(ind,1)
            }
            this.calculationB()
        },
        cancel(){
            this.$emit("cancelWidth")
        },
        //判断
        widthEdit(){
            this.widthObj.widthList.forEach((item,index)=>{
                item.width = item.width.filter((res=>{
                    return res !=null;
                     
                })) 
                item.width = item.width.filter((res=>{
                    return  res !='';
                     
                })) 
                item.width = item.width.filter((res=>{
                    return  res !=0;                    
                })) 
                if(item.length==''&&item.thickness==''){
                    item.length = item.length_formula
                    item.thickness = item.thickness_formula
                }
                if(item.length_formula==''&&item.thickness_formula==''){
                    this.widthObj.widthList.splice(index,1)
                }
            })         
            this.widthObjB.widthList.forEach((item,index)=>{
                item.width = item.width.filter((res=>{
                    return res !=null;
                     
                })) 
                item.width = item.width.filter((res=>{
                    return  res !='';
                     
                })) 
                item.width = item.width.filter((res=>{
                    return  res !=0;                    
                })) 
                if(item.length==''&&item.thickness==''){
                    item.length = item.length_formula
                    item.thickness = item.thickness_formula
                }
                if(item.length_formula==''&&item.thickness_formula==''){
                    this.widthObjB.widthList.splice(index,1)
                }
            }) 
            if(this.saleEdit){
                let obj = new Object();
                obj.sales_width = this.widthObj.widthList;
                obj.pre_width = this.widthObjB.widthList;
                obj.sales_cube = this.countCube;
                obj.sales_width_total = this.widthObj.widthList.map(a=>{
                    return a.countWidth
                })
                obj.sales_width_total = String(obj.sales_width_total);
                this.$emit("saleChange",JSON.parse(JSON.stringify(obj)))
                this.$emit("cancelWidth");
            }else{
                this.$emit("cancelWidth")
                this.is_sales = this.is_sales==true?1:0;
                this.$emit("returnwidth",JSON.parse(JSON.stringify(this.widthObj.widthList)))
            }
        },
        watchStock(){
            this.widthObj.widthList.map(a => {
                a.length_formula = this.$digitInput(a.length_formula, 2);
                a.thickness_formula = this.$digitInput(a.thickness_formula, 2);
            });
            this.widthObjB.widthList.map(a => {
                a.length_formula = this.$digitInput(a.length_formula, 2);
                a.thickness_formula = this.$digitInput(a.thickness_formula, 2);
            });
        },
    },
    watch:{
        edit:function(val){
            this.isCanEdit = val;
        },
        editReturn:function(val){
            this.returnEdit = val;
        },
        preType:function(val){
            this.internalPreType = val
        },
        initialCube:function(val){
            this.oldCube = val
        },
        codeSheetType:function(val){
            this.widthObj.codeSheetType = val;
        },
        list:function(val){
            this.widthObj.widthList = JSON.parse(JSON.stringify(val));
            this.oldList = JSON.parse(JSON.stringify(val));
            this.calculation();
        },
        listB:function(val){
            this.widthObjB.widthList = JSON.parse(JSON.stringify(val));
            this.oldListB = JSON.parse(JSON.stringify(val));
            this.calculationB();
        },
        dialogvisible:function(val){
            if(val){
                this.isEdit = false;
                this.isEditB = false;
                this.widthObj.widthList = JSON.parse(JSON.stringify(this.oldList));
            }
            this.calculation();
            this.calculationB();
        },
        isEdit:function(val){
            if(val==true){
                this.assignment();
            }else{
                this.assignmentFilter();
            }
        },
        isEditB:function(val){
            if(val==true){
                this.assignmentB();
            }else{
                this.assignmentFilterB();
            }
        },
    }
}
</script>
<style scoped>
    .overflow{overflow-y: auto;max-height: 600px}
    .spec >>> .el-form-item__label{width:50px;}
    .spec >>> .el-form-item__content{width:200px;}
    .pathTitleImg{width:17px;height:17px;display: inline-block;margin-left:10px;position: relative;top:2px;cursor: pointer;}
    .calcBox{display: flex}
    .calcBox .calCShell{display: flex;background-color: #ebedf4;padding:10px 0;padding-right:10px;border-radius: 5px 0 0 5px;width:50%;}
    .calcBox .calC{float: left;margin-left: 10px;display: flex;align-items: center;}
    .calcBox .caclTitle{font-size: 14px;line-height: 30px;float: left;}
    .calcBox .value{height:30px;line-height: 30px;font-size: 14px;padding:0 5px;width:80px;border-radius: 5px;border:1px solid #ccc;float: left;outline: none;}
    .calcBox .calcBtn{float: left;margin-left: 20px;font-size: 12px;color:#fff;background-color:#e25858;border-radius: 3px;height:30px;line-height: 30px;padding:0 15px;cursor: pointer;}
    .calcBox .total{background-color: #ebedf4;font-size: 14px;line-height: 30px;margin-left:5px;float: left;padding: 10px 0;border-radius: 0 5px 5px 0;width:50%;}
    .calC .handle{font-size: 24px;padding: 0 2px;color: #b21111}
    .totalWidthBox .top{position: relative;height: 45px;border-bottom: 1px solid #888;padding:0 20px;padding-top:5px;}
    .totalWidthBox .perBtn{float: left;position: relative;z-index: 1;}
    .totalWidthBox .title{position: absolute;left:0;right:0;margin: auto;line-height: 33px;z-index: 0;font-size: 16px;}
    .totalWidthBox .change{float:right;line-height: 33px;color: #b21111;cursor: pointer;position: relative;z-index: 1;}
    .delWidth{width:15px;height:15px;position: absolute;top:0;right:0;background: url('../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .noWidth{padding:20px 0;background-color: #ececec;color:#777;}
    .path{margin-bottom: 7px;text-align: left;display: flex;}
    .path .pathTitle{font-size:16px; font-weight:bold; color: #333333; border-right:4px solid #b21111; padding-right: 12px;}
    .showiIn{width: 50px;border-radius: 5px;border: 1px solid #ccc;outline: none;font-size: 13px;padding: 3px 5px;}
    .middle{display: flex;padding-right: 50px;position: relative;}
    .path .show{width: 45%}
    .path .formula{flex: 1}
    .path .titletext{padding-left: 20px}
    .allTotal{background-color: #ebedf4;font-size: 14px;line-height: 30px;padding: 5px 10px;border-radius: 5px;font-weight: 600;width: 100%;text-align: left;}
    .allTotalspan{padding: 0 20px;}
    .emptyStyle{position: absolute;padding: 2px 5px;border: 1px solid #999;border-radius: 5px;background-color: #b21111;color:#fff;cursor: pointer;right: 20px;}
    .whole{padding-bottom: 30px;}
    .dialogBtnList{height: 50px;}
</style>